import { Toaster as SonnerToaster, toast } from 'sonner';
import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-react';

/**
 * Transient feedback for the result of an action.
 *
 * Toasts are announced politely via the library's live region, so a keyboard or
 * screen-reader user learns that "Card moved" without a focus change. Anything
 * the user must act on belongs in a dialog, not here — a toast that disappears
 * is not a place to put a decision.
 *
 * Optimistic mutations in later phases use `toast.error` on rollback, which is
 * why the error variant is styled for legibility rather than subtlety.
 */
export function ToastProvider() {
  return (
    <SonnerToaster
      position="bottom-right"
      gap={8}
      offset={16}
      duration={4000}
      closeButton
      icons={{
        success: <CheckCircle2 className="size-4 text-success-fg" aria-hidden="true" />,
        error: <XCircle className="size-4 text-danger-fg" aria-hidden="true" />,
        warning: <AlertTriangle className="size-4 text-warning-fg" aria-hidden="true" />,
        info: <Info className="size-4 text-info-fg" aria-hidden="true" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            'group flex w-full items-start gap-3 rounded-md border border-border-subtle bg-surface-overlay p-3 shadow-e3',
          title: 'text-sm font-medium text-text-primary',
          description: 'text-xs text-text-secondary',
          actionButton:
            'rounded-sm bg-primary px-2 py-1 text-xs font-medium text-text-on-primary hover:bg-primary-hover',
          cancelButton:
            'rounded-sm bg-surface-sunken px-2 py-1 text-xs font-medium text-text-secondary hover:bg-surface-hover',
          closeButton:
            'border-border-default bg-surface-overlay text-text-tertiary hover:text-text-primary',
        },
      }}
    />
  );
}

export { toast };
